export default {
      id: "questionMark-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.1789552432127.svg#questionMark-usage",
      toString: function () {
        return this.url;
      }
    }